import React from 'react';
import { SupportedLanguage } from '../types';
import i18n from '../i18n/index';

interface LanguageSelectorProps {
  lang: SupportedLanguage;
  setLang: (lang: SupportedLanguage) => void;
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ lang, setLang }) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newLang = e.target.value as SupportedLanguage;
    setLang(newLang);
    if (i18n.isInitialized) {
      i18n.changeLanguage(newLang);
    }
    localStorage.setItem('vitacore_lang', newLang);
  };

  return (
    <select 
      value={lang}
      onChange={handleChange}
      className="fixed bottom-4 right-4 z-[50] bg-slate-800 text-slate-300 text-sm py-2 px-3 rounded-lg border border-slate-700 focus:outline-none focus:border-emerald-500 cursor-pointer hover:border-emerald-400 transition-colors"
    >
      <option value="en">🇬🇧 English</option>
      <option value="it">🇮🇹 Italiano</option>
      <option value="es">🇪🇸 Español</option>
      <option value="fr">🇫🇷 Français</option>
      <option value="pt">🇵🇹 Português</option>
      <option value="de">🇩🇪 Deutsch</option>
      <option value="pl">🇵🇱 Polski</option>
      <option value="nl">🇳🇱 Nederlands</option>
      <option value="ru">🇷🇺 Русский</option>
    </select>
  );
};
